import ScrollHint from 'scroll-hint';

export function tableScroll() {
  window.addEventListener('DOMContentLoaded', function () {
    new ScrollHint('.js-scrollable', {
      // scrollHintIconAppendClass: 'scroll-hint-icon-white',
      suggestiveShadow: true,
    });
  });
}
